// SMOOTH SCROLLING

// Thanks to: http://www.position-absolute.com/articles/better-html-anchor-a-jquery-script-to-slide-the-scrollbar/
jQuery.fn.anchorAnimate = function(settings) {

 	settings = jQuery.extend({
		speed : 1200
	}, settings);	

	return this.each(function(){
		var caller = this
		$(caller).click(function (event) {	
			event.preventDefault()
			var locationHref = window.location.href
			var elementClick = $(caller).attr("href")

			var destination = $(elementClick).offset().top;
			$("html:not(:animated),body:not(:animated)").animate({ scrollTop: destination}, settings.speed, function() {
				//window.location.hash = elementClick
			});
		  	return false;
		})
	})
}
// END SMOOTH SCROLLING





$(document).ready(function() {
	
	$("a.anchorLink").anchorAnimate();

	$(window).resize(function() {
 
		if ($(window).width()>=1100) {
		
			// if next prev arent visible, show them
			if($("div.prev-arrow").css({ opacity: 0 })) {
				$("div.prev-arrow").css({ opacity: 1 })
			}
			if($("div.next-arrow").css({ opacity: 0 })) {
				$("div.next-arrow").css({ opacity: 1 })
			}
			
		}else{
			// if next prev are visible, hide them
			if($("div.prev-arrow").css({ opacity: 1 })) {
				$("div.prev-arrow").css({ opacity: 0 })
			}
			if($("div.next-arrow").css({ opacity: 1 })) {
				$("div.next-arrow").css({ opacity: 0 })
			}
			
		}
		
	});
	
	$(window).resize();
});



